import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../store/actions';
import * as paramActions from '../../../components/paramHistory/store/actions';
import { fade } from '@material-ui/core/styles/colorManipulator';
import Chip from '@material-ui/core/Chip';
import {
    Grid,
    Tabs,
    Tab,
    IconButton,
    Icon,
    AppBar,
    Typography,
    List,
    ListItem,
    Card,
    CardContent,
    InputBase,
    Tooltip,
    Toolbar,
    InputAdornment,
    Select,
    Input,
    OutlinedInput,
    MenuItem,
    FormHelperText,
    InputLabel,
    ListSubheader,
} from '@material-ui/core';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { withRouter } from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import SearchIcon from '@material-ui/icons/Search';
import EventList from './EventList';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    draggableList: {
        height: '825px',
        background: theme.palette.background.default,
        padding: grid,
        overflow: 'auto',
    },
    eventCard: {
        width: '100%',
    },
    eventCardContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'flex-start',
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    },
})

const grid = 8;
const getListStyle = (isDraggingOver) => {
    if (isDraggingOver) {
        return {
            background: 'lightblue',
        }
    }
};

class LessonSchedule extends Component {

    state = { open: false }

    handleMultiSelectChange = (e, event_id, openName) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ [openName]: false })

        this.props.setUnscheduledEventRelation(e.target.value, event_id);
    }

    dropPrereq = (event, base_event) => {
        const filteredEventList = base_event.event_relation.filter(e => e != event);
        this.props.setUnscheduledEventRelation(filteredEventList, base_event.event_id);
    }

    getEventInfoByEventID = (event_id) => {
        const { leftItemsAssignment, leftItemsQuiz } = this.props;
        let event_type = '';
        let event_info = {};

        if (event_id.includes("assignment")) {
            event_type = 'assignment';
            event_info = leftItemsAssignment.find((event_info) => event_info.event_id === event_id);
        } else if (event_id.includes("quiz")) {
            event_type = 'quiz';
            event_info = leftItemsQuiz.find((event_info) => event_info.event_id === event_id);
        }

        return {
            event_type,
            event_info,
        }
    }

    onDragEnd = (result) => {
        const { source, destination, draggableId } = result;

        if (!destination) return;

        let { event_type, event_info } = this.getEventInfoByEventID(draggableId);

        if (source.droppableId === 'select_list' && destination.droppableId === 'event_list') {
            this.props.removeUnscheduledEvent(source, destination, event_type, event_info);
        }

        if (source.droppableId === 'event_list' && destination.droppableId === 'select_list') {
            this.props.addUnscheduledEvent(source, destination, event_type, event_info);
        }

        if (source.droppableId === 'select_list' && destination.droppableId === 'select_list') {
            this.props.moveUnscheduledEvent(source, destination, event_type, event_info);
        }
    }

    handleRemoveEvent = (event_info) => {
        this.props.removeUnscheduledEvent(
            { index: 0 },
            { index: 0 },
            event_info.eventType,
            event_info,
        )
    }

    getCardStyle = (color) => {
        return {
            borderRadius: 4,
            borderWidth: 2,
            borderColor: color,
        }
    }

    getSelectedEventTooltip = (event_info) => {
        if (event_info.event_relation.length === 0) {
            return (
                <Typography color="inherit" variant="subtitle2">No Prerequisites</Typography>
            );
        }

        return (
            <React.Fragment>
                <Typography color="inherit" variant="subtitle2" style={{ textDecoration: "underline" }}>Prerequisite List</Typography>
                {event_info.event_relation.map((event_id) => {
                    const event_rel_info = this.getEventInfoByEventID(event_id);

                    return (
                        <Typography key={event_id} color="inherit">- {event_rel_info.event_info.title}</Typography>
                    )
                })}
            </React.Fragment>
        )
    }

    getSelectedEventCard = (event_info, view_type, index = 0) => {
        const { classes, unscheduledEvents } = this.props;
        const openName = 'open_' + index;
        const open = this.state[openName] || false
        return (
            <Card
                key={event_info.id}
                className={classes.eventCard}
                style={this.getCardStyle(event_info.Color)}
            >
                <CardContent className={classes.eventCardContent}>
                    <Grid container spacing={8}>
                        <Grid item xs={12}>
                            <Grid container spacing={8}>
                                <Grid item xs={1}><Typography>({index + 1})</Typography></Grid>
                                <Grid item xs={10}><Typography>{event_info.title}</Typography></Grid>
                                {view_type === 'detail' ? null :
                                    <Grid item xs={1}>
                                        <IconButton
                                            style={{ padding: '0px', margin: '0px' }}
                                            onClick={() => this.handleRemoveEvent(event_info)}
                                        >
                                            <Icon>delete</Icon>
                                        </IconButton>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={8}>
                                <Grid item xs={1}></Grid>
                                <Grid item xs={10}>
                                    <Select
                                        open={open}
                                        onOpen={() => this.setState({ [openName]: true })}
                                        onClose={() => this.setState({ [openName]: false })}
                                        inputProps={{
                                            name: 'event_relation',
                                            id: 'event_relation',
                                        }}
                                        multiple
                                        value={event_info.event_relation}
                                        onChange={(e) => this.handleMultiSelectChange(e, event_info.event_id, openName)}
                                        style={{ width: '100%' }}
                                        // renderValue={(value) => <div>{value.length} prerequisite event(s) selected.</div>}
                                        renderValue={selected => (
                                            <div style={{ whiteSpace: 'normal' }}>
                                                {selected.map(event => (
                                                    <Chip style={{ marginTop: '3px', }} key={event} label={this.getEventName(event)} className={classes.chip} onDelete={() => this.dropPrereq(event, event_info)} />
                                                ))}
                                            </div>
                                        )}
                                        disabled={view_type === 'detail'}
                                    >
                                        {unscheduledEvents.slice(0, index).map((event_info, event_index) => (
                                            <MenuItem key={event_info.event_id} value={event_info.event_id}>
                                                {"(" + (event_index + 1) + ") " + event_info.title.substring(0, 60)}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    <FormHelperText>Event Requirements</FormHelperText>
                                </Grid>
                                <Grid item xs={1}>
                                    <Tooltip
                                        title={this.getSelectedEventTooltip(event_info)}
                                    >
                                        <Icon>info</Icon>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        )
    }

    getDetailView = () => {
        const { unscheduledEvents, view_type } = this.props;

        return (
            <React.Fragment>
                <AppBar position="static">
                    <div className="p-16 pr-4 flex flex-row items-center justify-between">
                        <Typography className="h3 pr-16" color="inherit">Event List</Typography>
                    </div>
                </AppBar>
                {unscheduledEvents.map((event_info, index) => (
                    <ListItem>
                        {this.getSelectedEventCard(event_info, view_type, index)}
                    </ListItem>
                ))}
            </React.Fragment>
        )
    }

    getEventName = (event) => {
        if (this.props.unscheduledEvents.length === 0) {
            return ''
        }
        const splitEvent = event.split('_');
        const d = this.props.unscheduledEvents.filter(e => e.eventType === splitEvent[0] && e.rel_id === Number(splitEvent[1]))[0]
        return d.title.slice(0, 50)
    }

    handleAddClick = (header, lesson_id) => {
        this.props.updateParams({ active: true, lesson_id: parseInt(lesson_id) })
        this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEvents, this.props.auth_id, this.props.companies);
        if (header === 'assignment') {
            this.props.history.push('/assignment/create')
        }
        else {
            this.props.history.push('/quiz/create')
        }
    }


    render() {
        const { classes, view_type, leftItemsAssignment, leftItemsQuiz, unscheduledEvents, currentLessonAssignmentList } = this.props;

        if (view_type === 'detail') {
            return this.getDetailView();
        }

        return (
            <React.Fragment>
                <DragDropContext
                    className={classes.root}
                    onDragEnd={this.onDragEnd}
                >
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                        <IconButton
                                style={{ padding: '0px', margin: '0px' }}
                                onClick={() => this.handleAddClick('assignment', this.props.lesson_id)}
                            >
                                <Icon>add</Icon>
                            </IconButton></Grid>
                        <Grid item xs={6}>
                            <EventList
                                currentLesson={this.props.currentLesson}
                                auth_id={this.props.auth_id}
                                companies={this.props.companies}
                                currentLessonAssignmentList={this.props.currentLessonAssignmentList}
                                currentLessonQuizList={this.props.currentLessonQuizList}
                                leftItemsAssignment={leftItemsAssignment}
                                leftItemsQuiz={leftItemsQuiz}
                                unscheduledEvents={unscheduledEvents}
                                isUnscheduled={true}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <AppBar position="static">
                                <div className="p-16 pr-4 flex flex-row items-center justify-between">
                                    <Typography className="h3 pr-16" color="inherit">Event List</Typography>
                                </div>
                            </AppBar>
                            <Droppable droppableId="select_list">
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        className={classes.draggableList}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                    >
                                        <List>
                                            {unscheduledEvents.map((event_info, index) => (
                                                <Draggable
                                                    key={event_info.event_id}
                                                    draggableId={event_info.event_id}
                                                    index={index}
                                                    listType='select_list'
                                                >
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                        >
                                                            <ListItem>
                                                                {this.getSelectedEventCard(event_info, view_type, index)}
                                                            </ListItem>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </List>
                                    </div>
                                )}
                            </Droppable>
                        </Grid>
                    </Grid>
                </DragDropContext>
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateParams: paramActions.updateCourseBuilderParams,
        saveLesson: Actions.saveLesson,
        addUnscheduledEvent: Actions.addUnscheduledEvent,
        moveCard: Actions.moveCard,
        removeEventFromCalendar: Actions.removeEventFromCalendar,
        addUnscheduledEvent: Actions.addUnscheduledEvent,
        moveUnscheduledEvent: Actions.moveUnscheduledEvent,
        removeUnscheduledEvent: Actions.removeUnscheduledEvent,
        setUnscheduledEventRelation: Actions.setUnscheduledEventRelation,
    }, dispatch);
}

function mapStateToProps({ calendarApp, }) {
    return {
    }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(LessonSchedule)));



// WEBPACK FOOTER //
// src/main/content/lesson/ScheduleComponents/UnscheduledLesson.js